import {
  PROGRESS_ROSTER_IMPORT,
  PROGRESS_ROSTER_IMPORT_ERROR,
  PROGRESS_ROSTER_IMPORT_SUCCESS,
} from "./actions";

const INIT_STATE = {
  importProcess: {
    data: null,
    loading: false,
    error: false,
    message: null,
  },
};

const rosterImportReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case PROGRESS_ROSTER_IMPORT:
      return {
        ...state,
        importProcess: {
          data: !action.payload.loading ? state.importProcess.data : null,
          loading: action.payload.loading,
          error: false,
          message: null,
        },
      };
    case PROGRESS_ROSTER_IMPORT_SUCCESS:
      return {
        ...state,
        importProcess: {
          ...state.importProcess,
          data: action.payload,
          loading: false,
          error: false,
          message: null,
        },
      };
    case PROGRESS_ROSTER_IMPORT_ERROR:
      return {
        ...state,
        importProcess: {
          ...state.importProcess,
          data: null,
          loading: false,
          error: true,
          message: action.payload,
        },
      };
    default:
      return state;
  }
};

export default rosterImportReducer;
